import React, { useEffect, useState } from "react";
import contactImg from "../assest/images/contact-us/cloud.webp";
import img1 from "../assest/images/banner-img/1.jpg";
import { Link } from "react-router-dom";
import { apiRequest } from "../services/allApi";
import { errorAlert, successAlert } from "../services/sweetAlert";
import { useLocation } from "react-router-dom";
import Loader from "../component/loader.jsx";
import { Helmet } from "react-helmet";

function BikeTours() {
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);

  // Mobile panel state
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [mobilePanelOpen, setMobilePanelOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("filter");

  const [homeData, setHomeData] = useState([]);
  const Home = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("home");
      setIsLoading(false);
      if (res?.success) {
        setHomeData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    Home();
  }, []);

  const [open, setOpen] = useState({
    price: true,
    style: true,
    type: true,
    duration: false,
    time: false,
    language: false,
  });
  const [showMore, setShowMore] = useState(false);

  const toggle = (key) => {
    setOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Recommended packages data
  const recommendedPackages = [
    {
      img: img1,
      title: "Leh-Ladakh Bike Expedition",
      location: "Leh, Nubra Valley",
      price: "₹2,898",
    },
    {
      img: img1,
      title: "Kashmir Great Lakes Trek",
      location: "Srinagar, Sonmarg",
      price: "₹3,500",
    },
    {
      img: img1,
      title: "Spiti Valley Adventure",
      location: "Manali, Kaza",
      price: "₹4,200",
    },
    {
      img: img1,
      title: "Golden Triangle Tour",
      location: "Delhi, Agra, Jaipur",
      price: "₹2,500",
    },
  ];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <Helmet>
        <title>Ladakh Bike Tour Packages | Ladakh MotoDrive</title>

        <meta
          name="description"
          content="Book Ladakh bike tour packages with Royal Enfield rides, fuel, stay & guide. Explore Leh, Nubra & Pangong with Ladakh MotoDrive."
        />

        <meta
          name="keywords"
          content="ladakh bike tour packages, leh ladakh bike trip, ladakh motorcycle tour, royal enfield ladakh trip, ladakh bike rental tour, leh bike trip itinerary, ladakh motodrive bike tour"
        />

        <link
          rel="canonical"
          href="https://ladakhmotodrive.com/ladakh-bike-tour-packages"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Ladakh Bike Tour Packages | Ladakh MotoDrive"
        />
        <meta
          property="og:description"
          content="ladakh bike tour packages, leh ladakh bike trip, ladakh motorcycle tour, royal enfield ladakh trip, ladakh bike rental tour, leh bike trip itinerary, ladakh motodrive bike tour"
        />
        <meta
          property="og:url"
          content="https://ladakhmotodrive.com/ladakh-bike-tour-packages"
        />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Ladakh Bike Tour Packages | Ladakh MotoDrive"
        />
        <meta
          name="twitter:description"
          content="ladakh bike tour packages, leh ladakh bike trip, ladakh motorcycle tour, royal enfield ladakh trip, ladakh bike rental tour, leh bike trip itinerary, ladakh motodrive bike tour"
        />
      </Helmet>

      <h1>Ladakh Bike Tour Packages</h1>
      {/* ===== Banner ===== */}
      <div className="container-fulid">
        <div className="cloud-img">
          <div className="cloud-move">
            <img src={contactImg} alt="cloud" />
          </div>
        </div>
        <div className="page-banner page-banner1">
          <div className="main-title">
            <h3 className="breadcrumb-title"> Ladakh Bike Tour Packages</h3>
            <ul className="breadcrumb-menu">
              <li>
                <a className="text-white" href="index.html">
                  Home
                </a>
              </li>
              <li>-</li>
              <li className="active">Bike Trip</li>
            </ul>
          </div>
        </div>
      </div>

      {/* ===== CONTENT ===== */}
      <section className="bg-light pt-5 pb-5">
        <div class="search-wrapper">
          <input
            type="text"
            placeholder="Search in Ladakh Bike Expedition | Leh Based Company ..."
            class="search-input"
          />

          <button class="search-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-search"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </button>
        </div>
        <div className="container">
          <div className="row">
            {/* ================= SIDEBAR ================= */}
            <div className="col-lg-4 desktop-sidebar">
              <div className="togo-tour-sidebar mb-30  ">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h4 className="mb-0">Filter</h4>

                  <a href="javascript:void(0);">Clear</a>
                </div>

                {/* PRICE RANGE WIDGET */}
                <PriceRange />

                {/* TOUR STYLES */}
                <Widget
                  title="Tour styles"
                  open={open.style}
                  toggle={() => toggle("style")}
                  items={["Natural", "Cuisine", "Biking", "Family"]}
                />

                {/* TOUR TYPES */}
                <div className="togo-tour-widget">
                  <h4
                    className="togo-tour-widget-title"
                    onClick={() => toggle("type")}
                  >
                    Tour types <span className="icon">⌃</span>
                  </h4>

                  {open.type && (
                    <div className="inner_content">
                      <ul>
                        {[
                          "Group tour",
                          "Private tour",
                          "Daily tour",
                          "Package tour",
                        ].map((item, i) => (
                          <li key={i}>
                            <input type="checkbox" id={item} />
                            <label htmlFor={item}>{item}</label>
                          </li>
                        ))}

                        {!showMore && (
                          <li>
                            <button onClick={() => setShowMore(true)}>
                              Show more
                            </button>
                          </li>
                        )}

                        {showMore && (
                          <>
                            {[
                              "City Tours",
                              "Cultural Tours",
                              "Family Friendly Tours",
                            ].map((item, i) => (
                              <li key={i}>
                                <input type="checkbox" id={item} />
                                <label htmlFor={item}>{item}</label>
                              </li>
                            ))}

                            <li>
                              <button onClick={() => setShowMore(false)}>
                                Show less
                              </button>
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  )}
                </div>

                {/* OTHER FILTERS */}
                <Widget
                  title="Duration"
                  open={open.duration}
                  toggle={() => toggle("duration")}
                  items={[
                    "0 - 3 hours",
                    "3 - 5 hours",
                    "5 - 8 hours",
                    "8 - 12 hours",
                  ]}
                />
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-lg-8">
              <div className="filter-topbar">
                {/* LEFT SIDE */}
                <div className="filter-left">
                  <span className="tour-count">24 tours found</span>

                  <button className="clear-filter">Clear filter</button>
                </div>

                {/* RIGHT SIDE */}
                <div className="filter-right">
                  <select className="sort-dropdown">
                    <option>Popular</option>
                    <option>Price Low → High</option>
                    <option>Price High → Low</option>
                    <option>Newest</option>
                  </select>
                </div>
              </div>

              <section className="  ">
                <div className="container">
                  {/* Heading */}

                  {/* Cards */}

                  <div className="row g-4">
                    {homeData?.tours
                      ?.filter((item) => item.category_name === "Bike")
                      .map((item, index) => (
                        <div className="col-lg-6 col-md-6" key={index}>
                          <div className="package-card">
                            <div className="package-card-img-wrap">
                              <Link
                                to={`/TourDetail/${item.slug}`}
                                className="card-img"
                              >
                                <img
                                  src={`${BASE_URL}${item?.image}`}
                                  alt={item.title}
                                />
                              </Link>

                              <div className="batch">
                                <span className="date">{item.duration}</span>

                                <div className="location">
                                  <ul className="location-list">
                                    <li>
                                      <Link to={`/TourDetail/${item.slug}`}>
                                        Ladakh
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to={`/TourDetail/${item.slug}`}>
                                        {item.tour_type}
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <div className="package-card-content">
                              <div className="card-content-top">
                                <h5>
                                  <Link to={`/TourDetail/${item.slug}`}>
                                    {item.title}
                                  </Link>
                                </h5>

                                <div className="location-area">
                                  <ul className="location-list scrollTextAni">
                                    {item.location?.split("-").map((loc, i) => (
                                      <li key={i}>
                                        <Link to={`/TourDetail/${item.slug}`}>
                                          {loc.trim()}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>

                              <div className="card-content-bottom">
                                <div className="price-area">
                                  <h6>Starting From:</h6>

                                  <span>
                                    ₹{item.price} <del>₹{item.mrp}</del>
                                  </span>

                                  <p>TAXES INCL/PERS</p>
                                </div>

                                <Link
                                  className="primary-btn2"
                                  to={`/TourDetail/${item.slug}`}
                                >
                                  Book a ride
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      {/* ================= MOBILE PANEL ================= */}
      {/* Mobile Toggle Button */}
      <div className="mobile-panel-toggle d-lg-none">
        <button
          className="mobile-filter-btn"
          onClick={() => setMobilePanelOpen(true)}
          aria-label="Open filters"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
          </svg>
          <span>Filter</span>
        </button>
      </div>

      {/* Mobile Panel Overlay */}
      <div
        className={`mobile-panel-overlay ${mobilePanelOpen ? "active" : ""}`}
        onClick={() => setMobilePanelOpen(false)}
      ></div>

      {/* Mobile Slide Panel */}
      <div className={`mobile-filter-panel ${mobilePanelOpen ? "open" : ""}`}>
        <div className="mobile-panel-header">
          <h3>Filter & Recommend</h3>
          <button
            className="mobile-panel-close"
            onClick={() => setMobilePanelOpen(false)}
            aria-label="Close panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Tab Navigation */}
        <div className="mobile-panel-tabs">
          <button
            className={`tab-btn ${activeTab === "filter" ? "active" : ""}`}
            onClick={() => setActiveTab("filter")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
            </svg>
            Filter
          </button>
          <button
            className={`tab-btn ${activeTab === "recommend" ? "active" : ""}`}
            onClick={() => setActiveTab("recommend")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
            Recommend
          </button>
        </div>

        {/* Tab Content */}
        <div className="mobile-panel-content">
          {/* Filter Tab Content */}
          {activeTab === "filter" && (
            <div className="filter-content">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h4 className="mb-0">Filter</h4>
                <a href="javascript:void(0);">Clear</a>
              </div>

              {/* Mobile Price Range */}
              <div className="mobile-price-widget togo-tour-widget">
                <h4 className="togo-tour-widget-title">
                  Price range <span>⌃</span>
                </h4>
                <div className="price-inputs">
                  <div>
                    <label>Min. price</label>
                    <input value="$0" readOnly />
                  </div>
                  <div>
                    <label>Max. price</label>
                    <input value="$2333" readOnly />
                  </div>
                </div>
              </div>

              {/* Mobile Tour Styles */}
              <Widget
                title="Tour styles"
                open={open.style}
                toggle={() => toggle("style")}
                items={["Natural", "Cuisine", "Biking", "Family"]}
              />

              {/* Mobile Tour Types */}
              <div className="togo-tour-widget">
                <h4
                  className="togo-tour-widget-title"
                  onClick={() => toggle("type")}
                >
                  Tour types <span className="icon">⌃</span>
                </h4>

                {open.type && (
                  <div className="inner_content">
                    <ul>
                      {[
                        "Group tour",
                        "Private tour",
                        "Daily tour",
                        "Package tour",
                      ].map((item, i) => (
                        <li key={i}>
                          <input type="checkbox" id={`mobile-${item}`} />
                          <label htmlFor={`mobile-${item}`}>{item}</label>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* Mobile Duration */}
              <Widget
                title="Duration"
                open={open.duration}
                toggle={() => toggle("duration")}
                items={[
                  "0 - 3 hours",
                  "3 - 5 hours",
                  "5 - 8 hours",
                  "8 - 12 hours",
                ]}
              />

              <button className="apply-filter-btn">Apply Filters</button>
            </div>
          )}

          {/* Recommend Tab Content */}
          {activeTab === "recommend" && (
            <div className="recommend-content">
              <h4>Recommended For You</h4>
              <p className="recommend-subtitle">Based on your preferences</p>

              <div className="recommended-packages">
                {recommendedPackages.map((pkg, index) => (
                  <div className="recommended-package-card" key={index}>
                    <div className="recommended-img">
                      <img src={pkg.img} alt={pkg.title} />
                    </div>
                    <div className="recommended-info">
                      <h5>{pkg.title}</h5>
                      <p className="location">{pkg.location}</p>
                      <span className="price">{pkg.price}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <section className="home-testimonial bg-light home-blog">
        <div className="container">
          <div className="row mt-4">
            <div className="col-lg-10 offset-lg-1">
              <div className="content-box text-center">
                {/* Short Content */}
                <p className="intro-text">
                  A journey through Ladakh on two wheels is one of the most
                  thrilling and unforgettable travel experiences in India. At
                  Ladakh MotoDrive, we offer expertly crafted Ladakh bike tour
                  packages that allow you to explore the region with complete
                  confidence, proper planning, and a true sense of adventure....
                </p>

                {/* FULL CONTENT */}
                {showMore && (
                  <div className="full-content text-start">
                    <p>
                      A journey through Ladakh on two wheels is one of the most
                      thrilling and unforgettable travel experiences in India.
                      At Ladakh MotoDrive, we offer expertly crafted Ladakh bike
                      tour packages that allow you to explore the region with
                      complete confidence, proper planning, and a true sense of
                      adventure. A Leh-Ladakh bike trip is not just about
                      reaching your destination; it is about embracing every
                      moment of the journey, from sharp mountain turns to
                      challenging climbs and breathtaking landscapes.
                    </p>

                    <p>
                      Riding through Ladakh gives you a unique connection with
                      nature, where every route offers something new, whether it
                      is high-altitude passes, peaceful valleys, or scenic
                      lakes. Our tours are designed for both beginners and
                      experienced riders.
                    </p>

                    <h4>Ladakh Bike Tour Packages Overview</h4>
                    <p>
                      We offer multiple Ladakh bike tour packages based on
                      duration and coverage, allowing travelers to choose
                      between short trips or extended journeys across Ladakh’s
                      scenic landscapes.
                    </p>

                    <ul>
                      <li>
                        Short-duration bike tours are ideal for travelers with
                        limited time who want a quick yet exciting Ladakh riding
                        experience without covering too many long-distance
                        routes.
                      </li>
                      <li>
                        Longer-duration tours provide a complete exploration of
                        Ladakh, covering major destinations, high mountain
                        passes, valleys, and cultural spots with a comfortable
                        and well-paced itinerary.
                      </li>
                      <li>
                        Popular options include 5-day, 7-day, and 9-day bike
                        tour packages designed to suit different travel
                        preferences, budgets, and adventure levels for all types
                        of riders.
                      </li>
                    </ul>

                    <p>
                      <b>Note:</b> T The Ladakh bike trip itinerary 7 days is
                      highly popular as it balances adventure and comfort,
                      covering major destinations without making the journey too
                      tiring or exhausting.
                    </p>

                    <h4>Ladakh Bike Rental</h4>
                    <p>
                      We provide reliable Ladakh bike rental services for
                      travelers who prefer the freedom of riding independently
                      or the support of guided tours. At Ladakh MotoDrive, our
                      fleet consists of well-maintained and high-performance
                      bikes that are specially suited for challenging
                      high-altitude conditions and rugged terrains. Travelers
                      can choose from popular options like Royal Enfield
                      Classic, Royal Enfield Himalayan, and other adventure
                      bikes known for their durability and comfort on mountain
                      roads. Each bike is regularly serviced to ensure safety
                      and smooth performance throughout the journey. All rentals
                      include essential safety gear such as helmets, along with
                      basic roadside assistance and support, allowing riders to
                      enjoy their Ladakh adventure with complete peace of mind.
                    </p>

                    <h4>Ladakh Bike Tour Routes</h4>
                    <ul>
                      <li>
                        Leh serves as the starting point where riders
                        acclimatize, explore local markets and monasteries, and
                        prepare for the upcoming high-altitude biking adventure
                        across Ladakh.
                      </li>
                      <li>
                        Khardung La offers an exciting ride through one of the
                        highest motorable passes, providing breathtaking
                        panoramic views and a thrilling high-altitude riding
                        experience for bikers.
                      </li>
                      <li>
                        Nubra Valley showcases stunning cold desert landscapes,
                        sand dunes, monasteries, and unique cultural
                        experiences, making it one of the most memorable stops
                        during the Ladakh bike journey.
                      </li>
                      <li>
                        Pangong Lake is known for its crystal-clear waters and
                        changing colors, offering a peaceful and scenic stop
                        that highlights the natural beauty of Ladakh.
                      </li>
                    </ul>

                    <h4>7-Day Ladakh Bike Trip Itinerary</h4>
                    <ul>
                      <li>
                        Day 1: Arrival in Leh for acclimatization, light
                        sightseeing, and rest to adjust to high altitude
                        conditions before beginning the adventurous bike journey
                        ahead.
                      </li>
                      <li>
                        Day 2: Ride from Leh to Nubra Valley via Khardung La,
                        enjoying scenic views, challenging roads, and
                        experiencing one of the highest motorable passes in the
                        world
                      </li>
                      <li>
                        Day 3: Explore Nubra Valley, visit monasteries, sand
                        dunes, and local villages while enjoying the peaceful
                        environment and unique culture of the region.
                      </li>
                      <li>
                        Day 4: Ride from Nubra Valley to Pangong Lake through
                        scenic routes, experiencing breathtaking landscapes and
                        capturing unforgettable views along the journey.
                      </li>
                      <li>
                        Day 5: Return ride from Pangong Lake to Leh, enjoying
                        the changing landscapes and reflecting on the
                        adventure-filled journey through Ladakh’s stunning
                        terrain.
                      </li>
                      <li>
                        Day 6: Spend the day exploring Leh's local attractions,
                        shopping in markets, visiting monasteries, and relaxing
                        after days of continuous riding and exploration.
                      </li>
                      <li>
                        Day 7:Departure from Leh with unforgettable memories of
                        the bike trip, scenic landscapes, and thrilling
                        experiences across Ladakh’s beautiful and challenging
                        routes.
                      </li>
                    </ul>

                    <h4>Ladakh Bike Tour Packages Cost</h4>
                    <p>
                      The Leh-Ladakh bike trip cost depends on several factors,
                      including the type of bike, duration of the tour,
                      accommodation category, and overall inclusions. On
                      average, packages start from around ₹20,000 per person and
                      can go up to ₹45,000 or more for extended trips with
                      premium services. Most packages offered by Ladakh
                      MotoDrive include accommodation, inner line permits,
                      backup support vehicles, and basic assistance throughout
                      the journey. However, additional expenses such as fuel,
                      meals, personal shopping, and optional activities may vary
                      based on individual preferences and travel style, allowing
                      flexibility in overall budget planning.
                    </p>

                    <h4>Best Time to Visit</h4>
                    <p>
                      The best time for a Ladakh bike tour is from June to
                      September, when the region becomes fully accessible and
                      offers the most favorable conditions for riding. During
                      these months, the major highways from Manali and Srinagar
                      to Leh are open, allowing riders to experience long scenic
                      routes without major roadblocks. The weather remains
                      relatively stable, with clear skies and manageable
                      temperatures during the day, making it ideal for long
                      rides across high-altitude passes. This period is perfect
                      for exploring popular routes like Leh, Nubra Valley, and
                      Pangong Lake, as well as crossing iconic passes such as
                      Khardung La. Riders can enjoy breathtaking landscapes,
                      smooth travel conditions, and vibrant local culture. While
                      days are comfortable, nights can still be cold due to
                      altitude, so proper gear is essential. Overall, this
                      season provides the safest and most enjoyable experience
                      for a Ladakh bike adventure.
                    </p>

                    <h4>FAQs</h4>
                    <p>
                      <b>1. What is the cost of a bike trip in Ladakh?</b>The
                      cost of a Ladakh bike trip usually starts from ₹20,000 per
                      person and can go up depending on the duration, type of
                      bike, accommodation, and overall package inclusions.
                    </p>
                    <p>
                      <b>2. Do I need to bring my own bike for the trip?</b> No,
                      you do not need to bring your own bike. We provide
                      well-maintained Ladakh bike rental options, including
                      Royal Enfield and Himalayan bikes suitable for
                      high-altitude terrain.
                    </p>
                    <p>
                      <b>3. Is Ladakh safe for a bike trip?</b>Yes, Ladakh is
                      safe for bike trips when properly planned. With guided
                      tours, support vehicles, and expert assistance from Ladakh
                      MotoDrive, riders can enjoy a secure and smooth
                      experience.
                    </p>
                    <p>
                      <b>4. What is the best time for a Ladakh bike trip?</b>{" "}
                      The best time for a Ladakh bike trip is from June to
                      September when roads are open, weather conditions are
                      stable, and riders can safely explore major routes and
                      destinations.
                    </p>
                    <p>
                      <b>5. What are the main routes covered in a bike tour?</b>
                      Most bike tours cover Leh, Nubra Valley, and Pangong Lake,
                      including passes like Khardung La, offering a perfect mix
                      of adventure, scenic beauty, and cultural experiences.
                    </p>
                  </div>
                )}

                {/* Button */}
                <button
                  className="read-btn"
                  onClick={() => setShowMore(!showMore)}
                >
                  {showMore ? "Read Less ↑" : "Read More ↓"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BikeTours;

/* ===============================
   REUSABLE WIDGET COMPONENT
================================*/

function Widget({ title, open, toggle, items }) {
  return (
    <div className="togo-tour-widget">
      <h4 className="togo-tour-widget-title" onClick={toggle}>
        {title} <span className="icon">⌃</span>
      </h4>

      {open && (
        <div className="inner_content">
          <ul>
            {items.map((item, i) => (
              <li key={i}>
                <input type="checkbox" id={item} />
                <label htmlFor={item}>{item}</label>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

/* ===============================
   PRICE RANGE COMPONENT
================================*/

function PriceRange() {
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(2333);

  const MIN_GAP = 50;
  const MAX_VALUE = 5000;

  const handleMin = (e) => {
    const value = Math.min(Number(e.target.value), max - MIN_GAP);
    setMin(value);
  };

  const handleMax = (e) => {
    const value = Math.max(Number(e.target.value), min + MIN_GAP);
    setMax(value);
  };

  const progress = {
    left: `INR{(min / MAX_VALUE) * 100}%`,
    right: `INR{100 - (max / MAX_VALUE) * 100}%`,
  };

  return (
    <div className="price-widget togo-tour-widget">
      <h4 className="togo-tour-widget-title">
        Price range <span>⌃</span>
      </h4>

      {/* SLIDER */}
      <div className="range-slider">
        <div className="slider-track"></div>
        <div className="slider-progress" style={progress}></div>

        <input
          type="range"
          min="0"
          max={MAX_VALUE}
          value={min}
          onChange={handleMin}
          className="range-min"
        />

        <input
          type="range"
          min="0"
          max={MAX_VALUE}
          value={max}
          onChange={handleMax}
          className="range-max"
        />
      </div>

      {/* PRICE BOX */}
      <div className="price-inputs">
        <div>
          <label>Min. price</label>
          <input value={`$${min}`} readOnly />
        </div>

        <div>
          <label>Max. price</label>
          <input value={`$${max}`} readOnly />
        </div>
      </div>
    </div>
  );
}
